<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section class="bg-primary text-white">
            <div class="row items-center">
              <div
                style="display: inline-block; font-family: 'Outfit', cursive"
                class="text-h6"
              >
                Users
              </div>
              <q-btn
                class="q-ml-md"
                color="white"
                text-color="white"
                icon="mdi-plus"
                flat
                @click="newDialog = true"
              ></q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                dark
                standout
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="users">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 160px) !important"
                >
                  <datatable
                    :filter="search"
                    :flat="true"
                    :data="users"
                    :columns="columns"
                    @rowSelected="handleDoubleClick"
                    @rowDoubleClick="handleDoubleClick"
                  />
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="newDialog" max-width="600px">
      <q-card v-if="newDialog" tile style="width: 90vw; max-width: 600px">
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div
              style="display: inline-block; font-family: 'Outfit', cursive"
              class="text-h6"
            >
              New User
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <userForm
            ref="newForm"
            @close="newDialog = false"
            @loadingStateChanged="(state) => (createLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                text
                color="primary"
                class="float-right"
                icon="mdi-plus"
                label="Create"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" max-width="600px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div
              style="display: inline-block; font-family: 'Outfit', cursive"
              class="text-h6"
            >
              User
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="viewDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <userForm
            ref="editForm"
            :data="viewFormData"
            @close="viewDetailsDialog = false"
            @loadingStateChanged="(state) => (saveLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                text
                color="primary"
                class="float-right q-mx-xs"
                icon="mdi-content-save-all"
                label="Save"
              >
              </q-btn>
              <q-btn
                @click="$refs.editForm.deleteUser()"
                :loading="saveLoading"
                text
                color="accent"
                class="float-right q-mx-xs"
                icon="mdi-delete"
                label="Delete"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import agGrid from "@/components/agGrid";
import expandedToolbar from "@/components/expandedToolbar";
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import userForm from "@/components/users/userForm.vue";
import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: {
    agGrid,
    expandedToolbar,
    datatable,
    userForm,
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "selectedRowData",
      "aGGridActionMenu",
      "users",
      "usersLoading",
    ]),
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "id",
        label: "ID",
        align: "left",
        field: "id",
        sortable: true,
      },

      {
        name: "name",
        label: "Name",
        align: "left",
        field: "name",
        sortable: true,
      },
      {
        name: "email",
        label: "Email",
        align: "left",
        field: "email",
        sortable: true,
      },
      {
        name: "username",
        label: "Username",
        align: "left",
        field: "username",
        sortable: true,
      },
      {
        name: "role",
        label: "Role",
        align: "left",
        field: "role",
        format: (val) => {
          switch (val) {
            case "Admin":
              return "Admin";
            case "OrgAdmin":
              return "Organisation Admin";
            case "OrgUser":
              return "Organisation User";
            default:
              return "";
          }
        },
        sortable: true,
      },
      {
        name: "created_at",
        label: "Created At",
        align: "left",
        field: "created_at",
        format: (val) =>
          val != null
            ? moment.utc(val).local().format("DD-MMM, YYYY h:mma")
            : "",
        sortable: true,
      },
      {
        name: "updated_at",
        label: "Updated At",
        align: "left",
        field: "updated_at",
        format: (val) =>
          val != null
            ? moment.utc(val).local().format("DD-MMM, YYYY h:mma")
            : "",
        sortable: true,
      },
    ],
    search: "",

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,
  }),
  beforeCreate() {
    this.$store.dispatch("loadUsers");
    this.$store.dispatch("loadOrganizations");
  },
  mounted() {
    if (this.aGGridActionMenu == true) {
      this.$store.dispatch("setAGGridActionMenuState", {});
    }
  },
  methods: {
    handleDoubleClick(row) {
      this.viewFormData = row;
      this.viewDetailsDialog = true;
    },
  },
};
</script>

<style scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}
</style>
